<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 21 18" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.2809 2.68143H0.779175V0.681427H20.2809V2.68143Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.2809 17.6222H0.779175V15.6222H20.2809V17.6222Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.2809 10.1518L0.77771 10.1518V8.15176L20.2809 8.15176V10.1518Z" fill="currentColor"/>
    </svg>
</template>